import { palette } from '$tablet-app/src/app/theme';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import React, { FC } from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import styled from 'styled-components/native';

interface Props {
  style?: StyleProp<ViewStyle>;
  iconSize?: number;
}

const EditBadge: FC<Props> = (props) => {
  return (
    <Badge style={props.style}>
      <FontAwesomeIcon icon="edit" color="white" size={props.iconSize || 25} />
    </Badge>
  );
};

const Badge = styled.View`
  border-radius: 20px;
  background-color: ${palette.primary_70};

  border: 2px white;

  justify-content: center;
  align-items: center;
`;

export default EditBadge;
